import editForm from './stocks-bonds-business-holdings.form';
import { CustomComponentType, CustomComponentLabel } from '../../../../enums/custom-component-type';
import { FinancialSubaccount } from '../financial-subaccount/financial-subaccount';

export class StocksBondsBusinessHoldingsWidget extends FinancialSubaccount {
	static schema(...extend: any) {
		return FinancialSubaccount.schema(
			{
				label: CustomComponentLabel()[CustomComponentType.stocksBondsBusinessHoldings],
				type: CustomComponentType.stocksBondsBusinessHoldings,
				key: CustomComponentType.stocksBondsBusinessHoldings,
				addAnother: 'Add a Stock, Bond, or Business Holding'
			},
			...extend
		);
	}

	static editForm = editForm;

	static get builderInfo() {
		return {
			title: CustomComponentLabel()[CustomComponentType.stocksBondsBusinessHoldings],
			group: '',
			weight: 10,
			schema: StocksBondsBusinessHoldingsWidget.schema()
		};
	}
}
